var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import RCTrigger from 'rc-trigger';
import { ConfigContext } from '../../../config-provider';
const BUILT_IN_PLACEMENTS = {
    bottom: {
        points: ['tc', 'bc'],
        offset: [0, 8],
        overflow: {
            adjustX: 1,
            adjustY: 1,
        },
    },
    bottomLeft: {
        points: ['tl', 'bl'],
        offset: [0, 8],
        overflow: {
            adjustX: 1,
            adjustY: 1,
        },
    },
    bottomLeft5: {
        points: ['tl', 'bl'],
        offset: [-5, 8],
        overflow: {
            adjustX: 1,
            adjustY: 1,
        },
    },
    bottomRight: {
        points: ['tr', 'br'],
        offset: [0, 8],
        overflow: {
            adjustX: 1,
            adjustY: 1,
        },
    },
    bottomRight30: {
        points: ['tr', 'br'],
        offset: [30, 8],
        overflow: {
            adjustX: 1,
            adjustY: 1,
        },
    },
    topLeft: {
        points: ['bl', 'tl'],
        offset: [0, -8],
        overflow: {
            adjustX: 0,
            adjustY: 1,
        },
    },
    topRight: {
        points: ['br', 'tr'],
        offset: [0, -8],
        overflow: {
            adjustX: 0,
            adjustY: 1,
        },
    },
};
const Trigger = props => {
    // 类名前缀
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('picker');
    const dropdownPrefixCls = `${prefixCls}-dropdown`;
    const { popupPlacement = 'bottomLeft' } = props, restProps = __rest(props, ["popupPlacement"]);
    return (<RCTrigger action={['hover']} popupPlacement={popupPlacement} builtinPlacements={BUILT_IN_PLACEMENTS} prefixCls={dropdownPrefixCls} {...restProps}>
      {props.children}
    </RCTrigger>);
};
export default Trigger;
